/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchAggregateSelector } from '../reducers/aggregate';
import { fetchAggregate as fetchAggregateAction } from '../actions/aggregate';
import RatingSummary from '../components/AggregateBar/RatingSummary';
import CellSummary from '../components/AggregateBar/CellSummary';

export class AggregateBar extends React.PureComponent {
    static propTypes = {
        location: PropTypes.shape({
            location_type: PropTypes.string,
            location_id: PropTypes.string,
        }),
        loading: PropTypes.bool,
        aggregate: PropTypes.shape({
            location_id: PropTypes.string,
            average_rating: PropTypes.number,
            number_of_ratings: PropTypes.number,
            star_counts: PropTypes.shape({
                1: PropTypes.number,
                2: PropTypes.number,
                3: PropTypes.number,
                4: PropTypes.number,
                5: PropTypes.number,
            }),
            aggregate_cell_coverage_ratings: PropTypes.arrayOf(
                PropTypes.shape({
                    carrier: PropTypes.string,
                    average_rating: PropTypes.number,
                    number_of_ratings: PropTypes.number,
                })
            ),
        }),
        fetchAggregate: PropTypes.func,
    };

    componentDidMount() {
        const { loading, aggregate, location, fetchAggregate } = this.props;
        if (!loading && (!aggregate || location.location_id !== aggregate.location_id)) {
            fetchAggregate({
                locationType: location.location_type,
                locationId: location.location_id,
            });
        }
    }

    render() {
        const { aggregate } = this.props;

        if (!aggregate || Object.keys(aggregate).length === 0) {
            return null;
        }

        return (
            <>
                <RatingSummary aggregate={aggregate} wrapper="li" />
                <CellSummary aggregate={aggregate} wrapper="li" />
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { data: aggregate } = fetchAggregateSelector(state);
    const { locationType, locationId } = ownProps;
    return {
        location: { location_id: locationId, location_type: locationType },
        aggregate,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchAggregate: fetchAggregateAction,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AggregateBar);

export const RatingSummaryContainer = connect(mapStateToProps)(RatingSummary);
export const CellSummaryContainer = connect(mapStateToProps)(CellSummary);
